import { lazy, Suspense ,useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Loading from "components/Spinner";
import { useAuth } from "contexts/AuthContextProvider";
import SessionExpired from "components/SessionExpired";
import SelfieUpdate from "pages/Re-KYC/SelfieUpdateURL";
import { useGetBulletinHooks } from "services/hooks";
import Bulletin from "components/Bulletin";
// import RedirectSso from "pages/Redirect-sso";
// import { getItem, setItem } from "utils/CommonUtils";

const NoMatch = lazy(() => import("components/NoMatch"));
const AuthHome = lazy(() => import("pages/AuthHome"));
const Login = lazy(() => import("pages/Login"));
const Redirect = lazy(() => import("pages/Redirect-sso"));
const RedirectSp = lazy(() => import("pages/Redirect-sp"));
const Dashboard = lazy(() => import("pages/Dashboard"));
function GuestRoute({ children }: { children: JSX.Element }) {
  const { access_token } = useAuth();
  let location = useLocation();
  if (access_token === undefined) return null;
  // if (access_token) {
  //   if (children.type.name !== "SelfieUpdate") {
  //     return <Navigate to={"/dashboard"} state={{ from: location }} />;
  //   }
  // }
  // if (access_token) {
  //   return <Navigate to={"/dashboard"} state={{ from: location }} />;
  // }
  if (access_token && location.pathname !== "/selfie") {
    return <Navigate to={"/dashboard"} state={{ from: location }} />;
  }
  return children;
}
function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { access_token } = useAuth();
  let location = useLocation();
  if (access_token === undefined) return null;
  if (!access_token) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
}

const RoutesScreen = () => {
  const [data,setData] = useState([]);
  const {GetBulletinMutate} = useGetBulletinHooks();
  useEffect(()=>{
    const getBulletin = async() => {
      const {payload,error} = await GetBulletinMutate("");
       if (payload?.result?.flag === 1) {
        setData(payload?.data);
      }
      if (error) {
        console.log(error)
      }
    }
    getBulletin();
  },[]);
  return (
    <Suspense fallback={<Loading />}>
       <Bulletin bulletinData={data}/>
      <Routes>
        <Route path="*" element={<NoMatch />} />
        <Route
          path="/auth/:token"
          element={
            <GuestRoute>
              <AuthHome />
            </GuestRoute>
          }
        />
        <Route
          path="/login"
          element={
            <GuestRoute>
              <Login />
            </GuestRoute>
          }
        />
        <Route
          path="/redirect-sp"
          element={
            <GuestRoute>
              <RedirectSp />
            </GuestRoute>
          }
        />
        <Route
          path="/redirect"
          element={
            <GuestRoute>
              <Redirect />
            </GuestRoute>
          }
        />
        <Route
          path="/sessionexpired"
          element={
            <GuestRoute>
              <SessionExpired />
            </GuestRoute>
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/selfie"
          element={
            <GuestRoute>
              <SelfieUpdate />
            </GuestRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesScreen;
